import React from 'react';
import style from './standView.module.scss';
import CustomCarousel from '../../stands/viewStand/CustomCarousel';

const Medium = ({stand}) => {
  const {
    banner,
    medLogo,
    medUp,
    medLowRi,
    medUpRi,
    medFiLe,
    medCe
  } = style;
  return (
    <>
      <div className={`${banner} ${medLogo}`}>
        {stand.logos && (
          <CustomCarousel images={stand.logos} alt="" />
        )}
      </div>

      <div className={`${banner} ${medUp}`}>
        {stand.upperBanner && (
          <CustomCarousel images={stand.upperBanner} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${medUpRi}`}>
        {stand.lowerRightBanner && (
          <CustomCarousel images={stand.lowerRightBanner} alt="awdad" />
          
        )}
      </div>

      <div className={`${banner} ${medLowRi}`}>
        {stand.fixedLeft && (
          <CustomCarousel images={stand.fixedLeft} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${medFiLe}`}>
        {stand.upperRightBanner && (
          <CustomCarousel images={stand.upperRightBanner} alt="awdad" />
        )}
      </div>

      <div className={`${banner} ${medCe}`}>
        {stand.center && (
          <CustomCarousel images={stand.center} alt="awdad" />
        )}
      </div>

    </>
  );
};

export default Medium;
